import React, { useState } from 'react'
import { Calendar, dateFnsLocalizer } from "react-big-calendar"
import { format, parse, startOfWeek, getDay } from "date-fns"
import { useQuery } from '@tanstack/react-query'
import ptBR from "date-fns/locale/pt-BR"
import { FiBell } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'

import "react-big-calendar/lib/css/react-big-calendar.css"

import Card from '../../../components/Card'
import Modal from '../../../components/Modal'
import { api, authHeaders } from '../../../services/api'
import { Button } from '../../../components/Form'
import Spinner from '../../../components/Spinner'
import FormCadastro from './FormCadastro'

const localizer = dateFnsLocalizer({
	format,
	parse,
	startOfWeek,
	getDay,
	locales: {
		'pt-BR': ptBR
	}
})

const messages = {
	date: "Data",
	time: "Hora",
	event: "Evento",
	allDay: "Dia inteiro",
	week: "Semana",
	work_week: "Semana útil",
	day: "Dia",
	month: "Mês",
	previous: "Anterior",
	next: "Próximo",
	yesterday: "Ontem",
	tomorrow: "Amanhã",
	today: "Hoje",
	agenda: "Agenda",
	noEventsInRange: "Não há agendamentos neste período.",
	showMore: total => `+${total} mais`
}

export default function () {
	const history = useHistory()

	const [isNovoLembreteOpen, setIsNovoLembreteOpen] = useState(false)

	const { data: lembretes, refetch: refetchLembretes } = useQuery({
		queryKey: ['obter-lista-lembretes'],
		queryFn: async () => {
			const response = await api.get('lembrete', authHeaders())

			return response.map(item => ({
				id: item.id,
				title: item.titulo,
				start: new Date(item.inicio),
				end: new Date(item.fim)
			}))
		}
	})

	return (
		<div>
			<Card className="flex flex-col gap-4 text-slate-800">
				<h1 className="text-slate-800">Agenda</h1>

				<Button 
					className="w-fit self-end" 
					onClick={() => {
						setIsNovoLembreteOpen(true)
					}}
					disabled={!lembretes}
				>
					Cadastrar um lembrete
					<FiBell size={16} />
				</Button>

				{lembretes ? (
					<Calendar
						localizer={localizer}
						events={lembretes}
						startAccessor="start"
						endAccessor="end"
						style={{ height: 500 }}
						messages={messages}
						culture="pt-BR"
						onSelectEvent={event => {
							history.push(`/agenda/evento/${event.id}`)
						}}
					/>
				) : (
					<Spinner />
				)}
			</Card>

			<Modal
				isOpen={isNovoLembreteOpen}
				title="Novo lembrete"
				handleClose={() => {
					setIsNovoLembreteOpen(false)
				}}
			>
				<FormCadastro 
					onSubmit={() => { 
						setIsNovoLembreteOpen(false)

						refetchLembretes()
					}} 
				/>
			</Modal>
		</div>
	)
}
